const Error = () => {
    return <p>Something went wrong !</p>;
};
export default Error;
